<script>
  export let mounted;
  export let currentPoem;
  export let poemsFormatted;
</script>

<pre
  class:visually-hidden="{mounted}"
  aria-live="polite">
{#if mounted}
{@html currentPoem}
{:else}
{#each poemsFormatted.filter((_,i) => i !== 0) as poem }
{@html poem}
{`

-------------------

`}
{/each}
{/if}
</pre>
